import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InstallationFlowType } from '../../../constants/app.constants';
import { KeyValueData } from '../../../domains/common.domain';
import { CommonService } from '../../../services/common.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { AllDropdownKeys } from '../../jurisdiction.constants';
import { InvoiceAddressFormData, LookupOptionsData } from '../../jurisdiction.domain';
import { PersonalDataService } from '../personal-data.service';
import { EnvironmentService } from '../../../services/environment.service';
import { ValidationsService } from 'src/app/services/validations.service';

@Component({
  selector: 'app-invoice-address',
  templateUrl: './invoice-address.component.html',
  styleUrls: ['./invoice-address.component.scss'],
})
export class InvoiceAddressComponent implements OnInit {
  @Input() invoiceAddress: InvoiceAddressFormData;
  @Input() isReadOnly: boolean = false;
  invoiceAddressDataFG: FormGroup;
  currentInstallationFlow: string;
  installationFlowType: KeyValueData;
  allTitles: LookupOptionsData[];
  titleKey: string;

  constructor(
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private personalDataService: PersonalDataService,
    public environmentService: EnvironmentService
  ) {
    this.installationFlowType = InstallationFlowType;
    this.currentInstallationFlow = this.localStorageService.getItem('installation_flow') || '';
    this.titleKey = AllDropdownKeys.Title;
    this.allTitles = this.commonService.getDropdownData(this.titleKey);
  }

  ngOnInit(): void {
    this.prepareForm();
    this.personalDataService.updatePersonalDataForm(this.invoiceAddressDataFG, 'invoiceAddress');
  }

  prepareForm(): void {
    this.invoiceAddressDataFG = new FormGroup({
      id: new FormControl(this.invoiceAddress?.id || ''),
      title: new FormControl(this.invoiceAddress?.title || '', [Validators.required]),
      firstName: new FormControl(this.invoiceAddress?.firstName || '', [Validators.required]),
      lastName: new FormControl(this.invoiceAddress?.lastName || '', [Validators.required]),
      company: new FormControl(this.invoiceAddress?.company || ''),
      street: new FormControl(this.invoiceAddress?.street || '', [Validators.required]),
      streetNo: new FormControl(this.invoiceAddress?.streetNo || '', [Validators.required, ValidationsService.streetNumberValidator()]),
      addressSuffix: new FormControl(this.invoiceAddress?.addressSuffix || ''),
      city: new FormControl(this.invoiceAddress?.city || '', [Validators.required]),
      postCode: new FormControl(this.invoiceAddress?.postCode || '', [Validators.required, ValidationsService.maxLengthValidator()]),
      telephone: new FormControl(this.invoiceAddress?.telephone || '', [Validators.required]),
      land: new FormControl(this.invoiceAddress?.land || '', [Validators.required]),
    });

    this.invoiceAddressDataFG.valueChanges.subscribe(() => {
      this.personalDataService.updatePersonalDataForm(this.invoiceAddressDataFG, 'invoiceAddress');
    });

    const emailValidators = this.environmentService.showEmailRequired ? [Validators.required] : [];
    const conditionalControls = [
      {
        name: 'mobile',
        condition: !this.environmentService.showEmailInsteadOfMobile,
        value: this.invoiceAddress?.mobile || '',
        validators: [],
      },
      {
        name: 'email',
        condition: this.environmentService.showEmailInsteadOfMobile || this.environmentService.showEmail,
        value: this.invoiceAddress?.email || '',
        validators: emailValidators,
      },
      {
        name: 'repeatEmail',
        condition: this.environmentService.showRepeatEmail,
        value: this.invoiceAddress?.email || '',
        validators: emailValidators,
      },
    ];

    conditionalControls.forEach(control => {
      if (control.condition) {
        this.invoiceAddressDataFG.addControl(control.name, new FormControl(control.value || '', control.validators));
      }
    });

    if (this.environmentService.showRepeatEmail && this.environmentService.showEmailRequired) {
      this.invoiceAddressDataFG.setValidators([ValidationsService.stringComparisonValidator('email', 'repeatEmail')]);
    }
  }
}
